import React, { useEffect, useMemo, useState } from 'react';

import './Integrations.scss';
import { useSelector } from 'react-redux';
import { Button, Divider, Form, InputNumber, Select, Switch } from 'antd';
import { useDispatch } from 'react-redux';

import { doCreateSetting, doGetSettings, doUpdateSetting } from '../../../modules/settings/store/thunk';
import { clearState, selectAllSettings } from '../../../modules/settings/store/slice';

import { useForm } from 'antd/es/form/Form';

export const DeliveryMethodSettings = () => {
  const dispatch = useDispatch();
  const [form] = useForm();

  const [saving, setSaving] = useState(false);

  const companies = useSelector((state) => state.auth.user.companies || [state.auth.user.company]);

  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  useEffect(() => {
    if (companies.length === 1) {
      setSelectedCompanyId(companies[0].id);
    }
  }, [companies]);

  const companyOptions = useMemo(() => companies.map((c) => ({ label: c.name, value: c.id })), [companies]);

  const settings = useSelector((state) => selectAllSettings(state));

  const settingKeys = [
    'MAX_SPARQLE_OPTIONS',
    'SHOW_TIME_WINDOWS',
    'SHOW_POSTNL_PICKUP',
    'MAX_POST_NL_PICKUP_POINT_OPTIONS',
  ];
  const booleanValues = ['SHOW_TIME_WINDOWS', 'SHOW_POSTNL_PICKUP'];

  useEffect(() => {
    console.log({ settings });
    form.resetFields(settingKeys);

    settings.forEach((s) => {
      if (booleanValues.includes(s.keyword)) {
        form.setFieldValue(s.keyword, s.value === 'true');
      } else {
        form.setFieldValue(s.keyword, s.value);
      }
    });
  }, [settings]);

  useEffect(() => {
    if (selectedCompanyId) {
      dispatch(doGetSettings({ category: 'delivery-methods', companyId: selectedCompanyId }));
    }
    return () => dispatch(clearState()); // explicitly clear the state to prevent it from being used in different component
  }, [selectedCompanyId]);

  const onFinish = async (values) => {
    setSaving(true);
    const updates = settingKeys.map((k) => ({
      id: settings.find((e) => e.keyword === k)?.id || null,
      keyword: k,
      value: values[k]?.toString() || null,
      group: 'DELIVERY_METHODS',
      companyId: selectedCompanyId,
    }));
    // send updates or creates to backend depending on their existance
    await Promise.all(
      updates.map(async (u) => {
        if (u.id && u.value) {
          // if it existed and has a value => update it
          await dispatch(doUpdateSetting(u));
        } else if (u.value) {
          // if it didn't exist => create it
          await dispatch(doCreateSetting(u));
        }
      }),
    );
    setSaving(false);
  };

  const watchShowPostnlPickup = Form.useWatch('SHOW_POSTNL_PICKUP', form);

  return (
    <div className="info">
      <div className="info-content">
        <h3>Delivery Methods</h3>
        <h5>Configure the delivery methods that apply to the delivery methods endpoint</h5>
      </div>
      <Select
        placeholder="Please select a company"
        className="select-small"
        options={companyOptions}
        onSelect={setSelectedCompanyId}
        style={{ minWidth: '200px' }}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}></div>
      <Divider />
      <Form form={form} scrollToFirstError onFinish={onFinish} layout="vertical">
        <h4>Sparqle delivery</h4>
        <Form.Item label="Maximum number of sparqle options in the checkout." name="MAX_SPARQLE_OPTIONS">
          <InputNumber style={{ maxWidth: 200 }} min={0} max={10} disabled={!selectedCompanyId} />
        </Form.Item>
        <Form.Item label="Show time windows for sparqle delivery options" name="SHOW_TIME_WINDOWS">
          <Switch disabled={!selectedCompanyId} />
        </Form.Item>
        <Divider />
        <h4>PostNL pickup points</h4>
        <Form.Item label="Show Post NL pickup points in checkout component." name="SHOW_POSTNL_PICKUP">
          <Switch disabled={!selectedCompanyId} />
        </Form.Item>
        <Form.Item
          label="Maximum number of Post NL pickup points in checkout component."
          name="MAX_POST_NL_PICKUP_POINT_OPTIONS"
        >
          <InputNumber
            style={{ maxWidth: 200 }}
            min={0}
            max={10}
            disabled={!watchShowPostnlPickup || !selectedCompanyId}
          />
        </Form.Item>

        <Button type="primary" size="small" htmlType="submit" loading={saving}>
          Save settings
        </Button>
      </Form>
    </div>
  );
};
